import { useFormik } from 'formik';
// mantine
import { Button, UnstyledButton } from '@mantine/core';
// components
import { IActor } from '@newo/api/gateway';
import ActorCombobox from '@/modules/Personas/components/ActorCombobox';
// utils
import { usePersonaQuery } from '@/services/bff/bff.queries.ts';
import validationSchema from '@/modules/Sandbox/components/SelectActorForm/SelectActorForm.schema.ts';

interface SelectActorFormProps {
    actor?: IActor;
    personaId?: string;
    onClose: () => void;
    onSubmit: (actor?: IActor) => void;
}

const SelectActorForm = ({
    actor,
    personaId = '',
    onClose,
    onSubmit
}: SelectActorFormProps) => {
    const { data: personaDetails } = usePersonaQuery(personaId);
    const actors: IActor[] = personaDetails?.actors ?? [];

    const formik = useFormik({
        initialValues: {
            actor
        },
        validationSchema,
        onSubmit(values) {
            if (values.actor) {
                onSubmit(values.actor);
                onClose();
            }
        }
    });

    const handleCancel = () => {
        onClose();
    };

    const handleChange = (selectedActorId?: string) => {
        formik.setFieldValue(
            'actor',
            actors.find((a) => a.id === selectedActorId)
        );
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <ActorCombobox
                actors={actors}
                value={formik.values.actor?.id}
                onChange={handleChange}
            />
            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        !formik.dirty || !formik.isValid || formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Save
                </Button>
            </div>
        </form>
    );
};

export default SelectActorForm;
